const catOne = [
  {
    link: "Electronics",
    name: "Electronics",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-0-Electronics.jpg",
  },
  {
    link: "Fashion",
    name: "Fashion",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-1-Fashion.jpg",
  },
  {
    link: "Home",
    name: "Home",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-2-Home.jpg",
  },
  {
    link: "beauty",
    name: "beauty",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-3-Beauty.jpg",
  },
];

const catTwo = [
  {
    link: "Sports",
    name: "Sports",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-4-Sports.jpg",
  },
  {
    link: "Accessories",
    name: "Accessories",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-5-Accessories.jpg",
  },
  {
    link: "gadgets",
    name: "gadgets",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-6-Gadgets.jpg",
  },
  {
    link: "Headphones",
    name: "Headphones",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-7-Headphones.jpg",
  },
];

const catThree = [
  {
    link: "Jeans",
    name: "Jeans",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-8-Jeans.jpg",
  },
  {
    link: "Shirts",
    name: "Shirts",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647683769-9-Shirts.jpg",
  },
  {
    link: "Shoes",
    name: "Shoes",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647701356-0-Shoes.jpg",
  },
  {
    link: "Jackets",
    name: "Jackets",
    image: "https://d5phhptdhx7pz.cloudfront.net/assets/images/1786647701356-1-Jackets.jpg",
  },
];

const HomeData = {
  category_a: catOne,
  category_b: catTwo,
  fashion: catThree,
};

export default HomeData;
